import { gql } from '@provision/graphql-client';
import { ADDRESS_SUMMARY_FIELDS } from 'src/graphql/entities/address/address.fragments';
import { CONVERSATION_PARTICIPANT_FIELDS } from 'src/graphql/entities/conversation-participants';

export const CONVERSATION_FIELDS = gql`
  fragment ConversationFields on Conversation {
    id
    conversationId
    workspaceConversationId
    conversationAssigneeId
    conversationAssigneeGroupId
    conversationStatusId
    conversationUrgencyId
    subject
    lastMessageReceivedAt
    requesterId
    createdAt
    type
    snoozeUntil
    conversationStatusUpdatedAt
    partnerId
    deletedAt
  }
`;

export const CONVERSATION_RELATIONS = gql`
  fragment ConversationRelations on Conversation {
    id
    requester {
      ...ConversationParticipantFields
      rsmEmail {
        id
        rsmEmailId
        value
        name
      }
    }
    associatedAddresses {
      ...AddressSummaryFields
    }
    summaries {
      id
      conversationSummaryId
      shortSummary
      createdAt
      updatedAt
      deletedAt
    }
  }
  ${CONVERSATION_PARTICIPANT_FIELDS}
  ${ADDRESS_SUMMARY_FIELDS}
`;

export const CONVERSATION_ATTACHMENT_FIELDS = gql`
  fragment ConversationAttachmentFields on ConversationAttachment {
    id
    conversationAttachmentId
    conversationId
    partnerId
    fileKey
    fileName
    contentType
    size
    createdAt
  }
`;

export const CONVERSATION_QUERY_FIELDS = gql`
  fragment ConversationQueryFields on Conversation {
    id
    ...ConversationFields
    ...ConversationRelations
  }
  ${CONVERSATION_FIELDS}
  ${CONVERSATION_RELATIONS}
`;

export const CREATE_CONVERSATION_QUERY_FIELDS = gql`
  fragment CreateConversationQueryFields on Conversation {
    id
    ...ConversationFields
  }
  ${CONVERSATION_FIELDS}
`;

export const SUBMIT_CONVERSATION_QUERY_FIELDS = gql`
  fragment SubmitConversationQueryFields on Conversation {
    id
    conversationId
    partnerId
  }
`;
